import { render, staticRenderFns } from "./sendCoupon.vue?vue&type=template&id=6dd05fb2&scoped=true&"
import script from "./sendCoupon.vue?vue&type=script&lang=js&"
export * from "./sendCoupon.vue?vue&type=script&lang=js&"
import style0 from "./sendCoupon.vue?vue&type=style&index=0&id=6dd05fb2&scoped=true&lang=css&"
import style1 from "./sendCoupon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd05fb2",
  null
  
)

export default component.exports